import { RootState } from '@store/store'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useAuth = () => {
    return useSelector((state: RootState) => state.auth)
}
